import {useContext} from "react";
import {Context} from "./store";

const AccessControl = ({publicChildren, children}) => {

    const [state, dispatch] = useContext(Context);
    return state.user && state.user.isAuthenticated ?
        children : publicChildren
}

export default AccessControl
